import React from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { listDataMessages } from "../messages";
import {useTheme} from "styled-components";

const table = [
  {
    header: "fieldID",
    value: "multipleBookingId",
  },
  {
    header: "fieldCheckIn",
    value: "checkin",
  },
  {
    header: "fieldCheckOut",
    value: "checkout",
  },
  {
    header: "fieldName",
    value: "customer",
  },
  {
    header: "fieldStatus",
    value: "status",
  },
  {
    header: "fieldAmount",
    value: "totalAmount",
  },
];

interface ListDataProps {
  checkin: string;
  checkout: string;
  customer: string;
  multipleBookingId: string;
  status: string;
  totalAmount: number;
}

export const ListData = ({ data }: { data: ListDataProps[] }) => {
  const intl = useIntl();
const theme = useTheme();
  return (
    <div className={`border rounded max-h-full h-full overflow-auto`}>
      <div className="p-4">
        <div className="flex flex-row items-center justify-between">
          <div className="text-lg font-semibold">
            <FormattedMessage {...listDataMessages.listDatatitle} />
          </div>
          <a
            href={`reservations`}
            className={`font-semibold bg-[${theme.buttonColor}] rounded-[24px] py-1.5 px-2.5 text-white text-[13px] leading-[19.5px]`}>
            {intl.formatMessage(listDataMessages.viewAllList)}
          </a>
        </div>

        <div className="flex pt-4 gap-1 border-b">
          <table className={`w-100`}>
            <thead>
              <tr>
                {table.map(({ header }: { header: string }) => (
                  <th
                    key={header}
                    className={`font-semibold text-[14px] max-w-[150px] min-w-[80px]`}>
                    <FormattedMessage {...listDataMessages[header]} />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row: ListDataProps, indexRow) => (
                <tr key={indexRow}>
                  {table.map(({ value }: { value: string }, index) => (
                    <td
                      key={index}
                      className="text-xs text-ellipsis overflow-hidden whitespace-nowrap max-w-[150px] min-w-[80px] leading-[18px]">
                      {row[value]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
